import { type Provider } from '@angular/core';

import { GRID_STATE_PERSISTENCE } from './in-memory-grid-state-persistence';
import { GRID_STATE_ID, LocalForageGridStatePersistence } from './local-forage-grid-state-persistence';

/**
 * Registers IndexedDB-backed layout persistence for a standalone `d-data-grid`.
 * Use a unique `gridStateId` per screen so two grids do not share one blob.
 * Does not register CAR orchestration (`provideDeightonGrid`).
 *
 * @param gridStateId - LocalForage key for this grid instance.
 * @returns Providers for the route or component injector.
 */
export function provideGridLayoutPersistence(gridStateId: string): Array<Provider> {
  return [
    { provide: GRID_STATE_ID, useValue: gridStateId },
    LocalForageGridStatePersistence,
    { provide: GRID_STATE_PERSISTENCE, useExisting: LocalForageGridStatePersistence }
  ];
}
